// US prospects route map — E-CRM01 (Funnel visibility in CRM).
//
//   /prospects                  all prospects (uniform list)
//   /prospects/abandoned        abandoned-funnel queue (status=ABANDONED)
//   /prospects/deposit-pending  DEPOSIT_PENDING queue
//   /prospects/switch-holds     switch-hold resolution case queue
//   /prospects/:prospectId      prospect detail + funnel timeline (AC1)
//
// RBAC is enforced by CrmShell's ROUTE_ACCESS matrix on the `/prospects`
// prefix (accounts/manager/admin/viewer), same as the /accounts prefix.

import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const ProspectsListPage = lazy(() =>
  import('./pages/ProspectsListPage').then((m) => ({ default: m.ProspectsListPage })),
);
const SwitchHoldCasesPage = lazy(() =>
  import('./pages/SwitchHoldCasesPage').then((m) => ({ default: m.SwitchHoldCasesPage })),
);
const ProspectDetailPage = lazy(() =>
  import('./pages/ProspectDetailPage').then((m) => ({ default: m.ProspectDetailPage })),
);

export const prospectsRoutes: RouteObject[] = [
  { path: '/prospects', element: <ProspectsListPage preset="all" /> },
  { path: '/prospects/abandoned', element: <ProspectsListPage preset="abandoned" /> },
  { path: '/prospects/deposit-pending', element: <ProspectsListPage preset="deposit-pending" /> },
  { path: '/prospects/switch-holds', element: <SwitchHoldCasesPage /> },
  { path: '/prospects/:prospectId', element: <ProspectDetailPage /> },
];
